<template>
    <div class="u-text-center" v-if="loading">
        불러오는 중입니다…
    </div>
    <div v-else>
        <h1>{{ page.title }}</h1>
        <div class="c-separator  c-separator--default  u-margin-bottom"></div>
        <div class="s-editor-content" v-html="page.comment"></div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "Page",
        props: ["id", "marxism"],
        data() {
            return {
                loading: true,
                page: null,
                error: false,
                swiper: undefined
            }
        },
        created() {
            axios.get('/data/page/' + this.id).then(response => {
                this.page = response.data;
                this.loading = false;
                window.Vue.nextTick(vm => {
                    this.afterPageLoad();
                });

                let pageTitle = this.page.title;
                document.querySelector('title').innerText = `${pageTitle} | ${this.marxism.title} - 마르크스주의 포럼`;

                if (window.gtag) {
                    // for google analytics page tracking
                    window.gtag('config', 'UA-2193909-1', {
                        'page_title': `${pageTitle} | ${this.marxism.title} - 마르크스주의 포럼`,
                        'page_path': (new URL(location.href)).pathname
                    });
                }

            }).catch(error => {
                this.page = {
                    'title': '페이지를 불러올 수 없습니다',
                    'comment': `<p>뭔가 잘못됐어요 😅</p><p>에러 메시지는 다음과 같습니다. 관리자에게 알려 주세요:<br><code>${error}</code></p>`
                };
                this.error = true;
                this.loading = false;
            })
        },
        methods: {
            afterPageLoad() {
                const swiperElement = this.$el.querySelector('.swiper-container');
                if (swiperElement) {
                    this.swiper = new window.Swiper(swiperElement, {
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        },
                        pagination: {
                            el: '.swiper-pagination',
                            clickable: true
                        }
                    })
                }
            }
        }
    }
</script>

<style scoped>

</style>
